import { Helmet } from "react-helmet";
import { BtnDefault } from "../../../../components/buttons/BtnDefault";
import { Header } from "../../../../components/Header";
import { DashboardLayout } from "../../../../components/layouts/DashboardLayout";
import { useState } from "react";
import { WaLogActivitySection } from "./sections/WaLogActivity";

export const WhatsAppMessagePage = () => {
    const [showSidebar, setShowSidebar] = useState(true);
    return (
        <>
            <Helmet>
                <title>Pesan WhatsApp - DANELA NET</title>
                <meta
                    name="description"
                    content="Kelola data whatsapp gateway, mengirim pesan broadcast dan private."
                />
            </Helmet>

            <DashboardLayout showSidebar={showSidebar} setShowSidebar={setShowSidebar}>
                {/* ===== Header ===== */}
                <Header toggleSidebar={() => setShowSidebar(!showSidebar)}>
                    <div className="flex items-center gap-3">
                        <h2 className="text-base md:text-xl font-bold text-gray-100">
                            Pesan WhatsApp
                        </h2>
                    </div>
                    {/* <BtnDefault onClick={openAddDeviceModal}>
                        <FaPlus className="text-xs hidden sm:block" />
                        <span>Tambah Device</span>
                    </BtnDefault> */}
                </Header>

                <main className="p-4 lg:p-6 space-y-5">
                    {/* Log Activity */}
                    <WaLogActivitySection />
                </main>

            </DashboardLayout>
        </>
    );
};